module.exports = __webpack_public_path__ + "static/media/1012805.776b24b9.png";